export const HEADING_FONT = `"Lugrasimo", cursive`;
export const HEADING_ALTERNATIVE = HEADING_FONT;
export const BODY_FONT = `"Newsreader", serif;`;
export const BODY_ALTERNATIVE = BODY_FONT;

